export default __webpack_public_path__ + "static/media/twitter.67ad063d.png";